import { IAccess, IClientAccess, Platforms, TActiveClientId, TReportsData, TUserdata, } from "@/ts/common-types";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { FaHome } from "react-icons/fa";

const PageNotFound = () => {

    const activeClientId: number = useSelector(
        (state: TActiveClientId) => +state.activeClientId.value
    );

    useEffect(() => {
        document.title = `Page not found | REVINITI`;
    }, []);
    const reportsData = useSelector(
        (state: TReportsData) => state.reportsData.value
    );

    const userData = useSelector((state: TUserdata) => state.userData.value);
    const userAccess = userData?.access?.find((access: IAccess) =>
        access.clients.find(
            (client: IClientAccess) => client.client_id === activeClientId
        )
    );
    const platformAccess = userAccess ? userAccess?.platforms.map((item: string) => item.toLowerCase()) : [];

    return (
        <div className="page-not-found pt-5">
            <div className="card bg-light shadow">
                <h2>
                    404
                </h2>
                <h3 className="mt-4">Oops! Page Not Found</h3>
                <h5>
                    We're sorry, the page you requested could not be found. You
                    may have accidentally mistyped the page address, or followed
                    an expired link. Please click the button below to get back
                    on the homepage.
                </h5>
                <div className="mt-5">
                    <Link
                        to={`${platformAccess.length === 1 && platformAccess.includes(Platforms.PLANNING) ?
                            `/${Platforms.PLANNING}/revstack/${reportsData?.revstack[0]?.report_id}` : "/"}`}
                        type="button"
                        className="btn m-2 m-md-0 btn-primary"
                    >
                        <div className="d-flex align-items-center gap-1">
                            <FaHome /> Back Home
                        </div>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default PageNotFound;
